// components/Login.jsx
import React, { useEffect, useState } from 'react';
import SquareCard from '../specific/loginCard'; // Asegúrate de que la ruta sea correcta
import Popup from '../specific/popUpResetPassword';
import Footer from '../common/footer';
import { useParams } from 'react-router-dom';
import { PatchPasswordUserService } from '../../Services/resetPasswordService';
import Header from '../common/header';
import { useTranslation } from "react-i18next";


function SetPassword() {
  const [t] = useTranslation("login")
  const [password, setPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [textBody, setTextBody] = useState('');

  const { id, idRequest } = useParams();

  const validatePassword = () => {
    // Comprobación de minúscula, mayúscula, número y carácter especial
    const hasLowerCase = /[a-z]/.test(password);
    const hasUpperCase = /[A-Z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(password);

    // Verifica que las contraseñas sean iguales
    if (password !== repeatPassword) {
      return t("setPassCardErrors.difference");
    }
    if (password.length < 8) {
      return t("setPassCardErrors.length");
    }
    if (!hasLowerCase) {
      return t("setPassCardErrors.loweCase");
    }
    if (!hasUpperCase) {
      return t("setPassCardErrors.upperCase");
    }
    if (!hasNumber) {
      return t("setPassCardErrors.number");
    }
    if (!hasSpecialChar) {
      return t("setPassCardErrors.specialChar");
    }

    return ''; // Todo está bien
  };

  const handleResetPassword = async (e) => {
    setLoading(true)
    e.preventDefault();
    const error = validatePassword();
    if (!error) {
      const response = await PatchPasswordUserService(id, idRequest, password);
      setTextBody(response.message);
      setLoading(false)
      setShowPopup(true)
    } else {
      setLoading(false)
      setError(true); setErrorMessage(error);
    }
  };


  const handleClosePopup = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    localStorage.removeItem("authInfo");
  }, [])

  return (
    <div>
      <Header
        translucent
        showUpdate={false}
      />
      <SquareCard
        buttonText={t("setPassCard.login")}
        onSubmit={handleResetPassword}
        setPassword={setPassword}
        error={error}
        errorMessage={errorMessage}
        setRepeatPassword={setRepeatPassword}
        type="set-password"
        showSetPassword
        loading={loading}

      />
      <Popup show={showPopup} handleClose={handleClosePopup} title={`${t("popupSuccessResetPass.title")}`} textBody={textBody} />
      <Footer absolutePosition />
    </div>
  );
}

export default SetPassword;